export default __webpack_public_path__ + "static/media/unpin-grey.33bc08b0.svg";